import React from 'react-x';
import propTypes from 'prop-types-x';
import { FacebookShareButton, PinterestShareButton, TwitterShareButton } from 'react-share';
import { CORE_GTM_TRACKING_VALUES } from '../../constants/analytics.js';
import { fireGTMTrackingEvent } from '../../utilities/fireGTMTrackingEvent.js';
import { CssAnimation } from './CssAnimation.jsx';

const NETWORK_MAP = {
  facebook: {
    Component: FacebookShareButton,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none"><path d="M3.324 21.8H7.308V11.948H10.62L11.136 8.10795H7.308V5.70795C7.27319 5.20819 7.41318 4.71187 7.704 4.30395C7.90476 4.11219 8.14565 3.96749 8.40924 3.88032C8.67282 3.79315 8.9525 3.7657 9.228 3.79995H11.268V0.367953C10.2814 0.239458 9.28677 0.183308 8.292 0.199953C7.63351 0.171438 6.97596 0.274555 6.35781 0.503269C5.73966 0.731984 5.17334 1.0817 4.692 1.53195C4.21843 2.02816 3.85247 2.61685 3.61707 3.26111C3.38166 3.90538 3.28189 4.59132 3.324 5.27595V8.10795H0V11.948H3.324V21.8Z" fill="#1A1A1F"/></svg>,
  },
  twitter: {
    Component: TwitterShareButton,
    icon: <svg xmlns="http://www.w3.org/2000/svg"  width="20" height="20" viewBox="0 0 22 22.4"><path d="M13.1,9.5L21.3,0h-1.9l-7.1,8.2L6.5,0H0l8.6,12.5L0,22.4h1.9l7.5-8.7l6,8.7H22L13.1,9.5L13.1,9.5z M10.4,12.6l-0.9-1.2L2.6,1.5h3l5.6,8l0.9,1.2L19.3,21h-3L10.4,12.6L10.4,12.6z" fill="#1A1A1F" /></svg>,
  },
  pinterest: {
    Component: PinterestShareButton,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none"><path d="M16.9601 2.06345C15.7716 1.4854 14.4657 1.18971 13.1441 1.19945C12.2612 1.19736 11.3818 1.31031 10.5281 1.53545C8.85053 1.9767 7.33204 2.88364 6.14812 4.15145C5.56853 4.78072 5.11259 5.51349 4.80412 6.31145C4.47758 7.15289 4.31467 8.04893 4.32412 8.95145C4.32455 9.41518 4.3728 9.87763 4.46812 10.3315C4.56598 10.811 4.70654 11.2809 4.88812 11.7355C5.06874 12.1846 5.33811 12.5928 5.68012 12.9355C6.00585 13.2844 6.42083 13.5375 6.88012 13.6675H7.09612C7.28812 13.6675 7.44412 13.4755 7.57612 13.0795C7.68827 12.7751 7.75302 12.4554 7.76812 12.1315C7.74681 11.9893 7.69346 11.8539 7.61212 11.7355L7.25212 11.1475C6.92477 10.5516 6.75152 9.88332 6.74812 9.20345C6.72755 8.42091 6.86943 7.6426 7.16478 6.91765C7.46013 6.19269 7.90255 5.53683 8.46412 4.99145C9.03824 4.43748 9.71707 4.00357 10.4609 3.7151C11.2047 3.42663 11.9986 3.28941 12.7961 3.31145C14.1459 3.25502 15.4682 3.70433 16.5041 4.57145C16.9838 5.0125 17.3596 5.5545 17.6045 6.15836C17.8493 6.76222 17.9571 7.41289 17.9201 8.06345C17.922 8.49687 17.894 8.92991 17.8361 9.35945C17.7772 9.84351 17.6931 10.3242 17.5841 10.7995C17.4633 11.2893 17.2987 11.7672 17.0921 12.2275C16.8865 12.6496 16.6414 13.0514 16.3601 13.4275C16.0944 13.7993 15.745 14.1035 15.3401 14.3155C14.9331 14.5295 14.48 14.6407 14.0201 14.6395C13.5086 14.6565 13.0101 14.476 12.6281 14.1355C12.4385 13.9649 12.2878 13.7555 12.1864 13.5215C12.0849 13.2875 12.035 13.0344 12.0401 12.7795C12.1117 11.9553 12.3058 11.1463 12.6161 10.3795C12.9293 9.58494 13.1195 8.74731 13.1801 7.89545C13.201 7.41395 13.0476 6.94106 12.7481 6.56345C12.5994 6.39235 12.4148 6.25628 12.2073 6.16499C11.9998 6.07371 11.7747 6.02947 11.5481 6.03545C11.2055 6.03665 10.8687 6.12412 10.5688 6.28981C10.2689 6.45549 10.0155 6.69404 9.83212 6.98345C9.39806 7.57074 9.16265 8.28117 9.16012 9.01145C9.11113 9.75242 9.23008 10.4949 9.50812 11.1835C9.44812 11.4475 9.23212 12.3235 8.83612 13.8235C8.44012 15.3235 8.16412 16.5595 7.97212 17.5435C7.80255 18.4298 7.7102 19.3292 7.69612 20.2315C7.69612 20.4955 7.75612 21.3115 7.88812 22.6315L8.00812 22.7635L8.18812 22.6915C8.51212 22.2715 8.77612 21.8875 8.99212 21.5755C9.21054 21.2508 9.41084 20.9142 9.59212 20.5675C9.77212 20.2195 9.91612 19.9435 10.0001 19.7635C10.1389 19.4645 10.2553 19.1557 10.3481 18.8395C10.4681 18.4075 10.5641 18.0955 10.6121 17.9155L10.9121 16.7155L11.2721 15.2635C11.5448 15.7582 11.964 16.1565 12.4721 16.4035C13.0185 16.6681 13.617 16.8075 14.2241 16.8115C15.0696 16.8226 15.9079 16.655 16.6841 16.3195C17.4196 16.0135 18.0821 15.5554 18.6281 14.9755C19.1476 14.3947 19.5838 13.7444 19.9241 13.0435C20.2646 12.3271 20.5223 11.5742 20.6921 10.7995C20.8475 10.0088 20.9279 9.20522 20.9321 8.39945C20.9769 7.03897 20.5905 5.69916 19.8281 4.57145C19.1147 3.49309 18.124 2.62676 16.9601 2.06345Z" fill="#1A1A1F"/></svg>
  },
  generic: {
    Component: SocialMediaShareCustomBtn,
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 24 24" fill="none"><path d="M16 6L8 11M8 13L16 18" stroke="#101010" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5" cy="12" r="3" stroke="#101010" stroke-width="2"/><circle cx="19" cy="5" r="3" stroke="#101010" stroke-width="2"/><circle cx="19" cy="19" r="3" stroke="#101010" stroke-width="2"/></svg>,
    handler: shareImageViaWebShareAPI,
    disabled: !navigator.canShare
  },
};

export function SocialMediaShareBtn(props) {

  const { 
    name, 
    url,
    getBlob,
    filename,
    media,
    cssAnimation,
    cssAnimationDelay,
    gtmComponentGroup, 
    gtmComponentName
  } = props;

  const icon = NETWORK_MAP[name].icon;
  const handler = NETWORK_MAP[name].handler;
  const disabled = NETWORK_MAP[name].disabled;
  const Component = NETWORK_MAP[name].Component;

  function clickHandler() {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.socialEvent,
      componentName: gtmComponentName,
      componentGroup: gtmComponentGroup,
      action: CORE_GTM_TRACKING_VALUES.action.share,
      label: window.location.href,
      socialChannel: name
    });
  };

  return ( !disabled && 
    <Component url={url} media={media} handler={() => handler(getBlob, filename)}>
      <CssAnimation 
      enter={{name: 'scale-up-0-1', duration: 1.25, delay: `${cssAnimationDelay}, hidden`}}
      triggerEnter={true}
      disable={!cssAnimation}
      >
        <span className={`c-social-media-share-btn c-social-media-share-btn--${name}`} onClick={clickHandler}>
          { icon }
        </span>
      </CssAnimation>
    </Component>
  )
};

function SocialMediaShareCustomBtn(props) {
  const {
    url,
    media,
    handler
  } = props;

  return (
    <button className="react-share__ShareButton" onClick={handler}>
      {props.children}
    </button>
  )
}

async function shareImageViaWebShareAPI(getBlob, filename) {
  try {
    const blob = await getBlob();

    const shareData = {
      files: [
        new File([blob], `${filename}.jpg`, {
          type: 'image/jpeg',
          lastModified: new Date().getTime()
        })
      ]
    };

    if (navigator.canShare && navigator.canShare(shareData)) {
      return navigator.share(shareData)
    }

  } catch (err) {
    console.log(err)
  }
}

SocialMediaShareBtn.propTypes = {
  name: propTypes.string.isRequired,
  url: propTypes.string.isRequired,
  media: propTypes.string,
  cssAnimation: propTypes.bool,
  cssAnimationDelay: propTypes.number,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string
};

SocialMediaShareBtn.defaultProps = {
  cssAnimation: true,
  cssAnimationDelay: 0,
  gtmComponentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.campaigns,
  gtmComponentName: CORE_GTM_TRACKING_VALUES.componentName.socialMediaSharebutton
};